import { useEffect, useState } from "react";
import { getAuditFiles, getPallasReportData } from "../api/Service";
import "../PallasReport/PallasReport.css";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "../../codercompanion/components/infinite-scroll";
import fileIcon from "../../../../src/assets/open-folder.png";

const PallasReport = () => {
  const [reportData, setReportData] = useState([]);
  const [auditFiles, setAuditFiles] = useState([]);
  const [hasMany, setHasMany] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [reportPage, setReportPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const versionsList = [10, 11];
  const [selectedHeaderId, setSelectedHeaderId] = useState(null);
  const [selectedFileLabel, setSelectedFileLabel] = useState("");
  const [isFileDropdownOpen, setIsFileDropdownOpen] = useState(false);
  const totalPageCount = Math.ceil(totalPages / pageSize);
  const [isReportUnavailable, setIsReportUnavailable] = useState(false);

  const getData = async (page, load_more) => {
    try {
      setIsLoading(true);
      const response = await getAuditFiles(page);
      //console.log("AUDIT_FILES:::", response);
      if (load_more) {
        setAuditFiles([...auditFiles, ...response]);
      } else {
        setAuditFiles(response);
      }
      setHasMany(true);
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
    } catch (error) {
      console.log("Error fetching audit files:", error);
      setHasMany(false);
      if (!load_more) {
        setAuditFiles([]);
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getData(1);
  }, []);

  const fetchReport = async (headerId, version, page = 1) => {
    try {
      setIsLoading(true);
      setIsReportUnavailable(false);

      const payload = {
        header_id: headerId,
        page_number: page,
        page_size: pageSize,
        version: version,
      };

      const res = await getPallasReportData(payload);

      setReportData(res?.data || []);
      setTotalPages(res?.total_records || 1);
    } catch (error) {
      console.log("wegdfh", error?.response.status);
      if (error?.response?.status === 400) {
        setIsReportUnavailable(true);
      }
      setReportData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileSelect = (file) => {
    const defaultVersion = versionsList[0]; // first item dynamically
    setSelectedHeaderId(file.header_id);
    setSelectedFileLabel(file.file_name.join(", "));
    setSelectedVersion(defaultVersion);
    setReportPage(1);
    fetchReport(file.header_id, defaultVersion, 1);
  };

  const handlePageChange = (page) => {
    setReportPage(page);
    fetchReport(selectedHeaderId, selectedVersion, page);
  };
  const roundedValues = reportData.map(item =>
  Math.round(Number(item.predicted_drg1_reimbursement_delta))
);

const min = Math.min(...roundedValues);
const max = Math.max(...roundedValues);
const getFinalHeatColor = (value, min, max) => {
  if (min === max) {
    return "#f4a261"; 
  }

  const ratio = (value - min) / (max - min);

  if (ratio >= 0.66) {
    return "#f8696b"; 
  } else if (ratio >= 0.33) {
    return "#f4a261"; 
  } else {
    return "#63be7b";
  }
};

  return (
    <>
      {!selectedHeaderId ? (
        <div className="file-select-container">
          <div className="file-select-card">
            <div className="file-icon-wrapper">
              <img src={fileIcon} alt="file" />
            </div>
            <div className="d-flex justify-content-between flex-column align-items-center">
                          <h2>Select File</h2>
            <p>Select a file to generate the Optimisation Report</p>

            </div>


            <div className="modern-dropdown-wrapper">
              <div
                className="modern-dropdown-trigger"
                onClick={() => setIsFileDropdownOpen(!isFileDropdownOpen)}
              >
                {selectedFileLabel || "Choose File"}
                <span className="dropdown-arrow">▾</span>
              </div>
              {isFileDropdownOpen && (
                <InfiniteScroll
                  className="modern-dropdown-panel"
                  hasData={hasMany}
                  loadMore={() => getData(currentPage, true)}
                  isLoading={isLoading}
                >
                  {auditFiles.map((item) => (
                    <div
                      key={item.header_id}
                      className={`modern-file-card ${
                        selectedHeaderId === item.header_id ? "selected" : ""
                      }`}
                      onClick={() => {
                        handleFileSelect(item);
                        setIsFileDropdownOpen(false);
                      }}
                    >
                      <div className="file-date">
                        {item.start_date} - {item.end_date}
                      </div>

                      <div className="file-name">
                        File: {item.file_name.join(", ")}
                      </div>

                      <div className="file-loadid">Load ID: {item.load_id}</div>
                    </div>
                  ))}
                </InfiniteScroll>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="pallas-report-layout">
          <div className="report-header">
            <h3>Enhance Optimisation Report</h3>
            <div className="report-actions">
              <span className="selected-file-label">{selectedFileLabel}</span>
              <select
                className="version-select"
                value={selectedVersion || ""}
                onChange={(e) => {
                  const version = Number(e.target.value);
                  setSelectedVersion(version);
                  setReportPage(1);
                  fetchReport(selectedHeaderId, version, 1);
                }}
              >
                <option value="" disabled>
                  Select Version
                </option>
                {versionsList.map((version) => (
                  <option key={version} value={version}>
                    Version {version}
                  </option>
                ))}
              </select>

              <button
                className="change-file-modern"
                onClick={() => {
                  setSelectedHeaderId(null);
                  setSelectedVersion(null);
                  setReportData([]);
                }}
              >
                ⟵ Change File
              </button>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="pallas-report-table">
              <thead>
                <tr>
                  <th>Episode ID</th>
                  <th>Speciality</th>
                  <th>Age</th>
                  <th>Admission Date</th>
                  <th>Discharge Date</th>
                  <th>Length Of Stay</th>
                  <th>Principal Diagnosis</th>
                  <th>Principal Procedure Code</th>
                  <th>Actual DRG</th>
                  <th>Predicted DRG1</th>
                  <th>Predicted DRG2</th>
                  <th>Predicted Drg1 Path</th>
                  <th>Predicted Drg2 Path</th>
                  {/* <th>Actual Weight</th> */}
                  {/* <th>Predicted DRG1 Weight</th> */}
                  {/* <th>Predicted DRG2 Weight</th> */}
                  <th>Actual Reimbursement</th>
                  <Tooltip title="Predicted DRG1 Reimbursement">
                    <th>Predicted DRG1 Reimbursement</th>
                  </Tooltip>
                  <Tooltip title="Predicted DRG2 Reimbursement">
                    <th>Predicted DRG2 Reimbursement</th>
                  </Tooltip>
                  <Tooltip title="Predicted DRG1 Reimbursement Delta">
                    <th>Predicted DRG1 Reimbursement Delta</th>
                  </Tooltip>
                  <Tooltip title="Predicted DRG2 Reimbursement Delta">
                    <th>Predicted DRG2 Reimbursement Delta</th>
                  </Tooltip>
                  <th className="sticky-right">Pallas Priority</th>
                </tr>
              </thead>
              <tbody>
                {reportData?.length > 0 ? (
                  reportData.map((item, index) => 
                    {
                      const roundedValueDelta1 = Math.round(Number(item.predicted_drg1_reimbursement_delta));
                      const roundedValueDelta2 = Math.round(Number(item.predicted_drg2_reimbursement_delta));

                      return (
                        <tr
                          key={index}
                          className={`row-${item.pallas_priority?.toLowerCase()}`}
                        >
                          <td>
                        <span className="code-pill">{item.id}</span>
                      </td>
                      <td>{item.speciality}</td>
                      <td>
                        <span>{item.age}</span>
                      </td>
                      <td>{item.adm_date}</td>
                      <td>{item.sep_date}</td>
                      <td>{item.los}</td>
                      <td>{item.principal_diagnosis}</td>
                      <td>{item.principal_procedure_code}</td>
                      <td>{item.actual_drg}</td>
                      <td>{item.predicted_drg1}</td>
                      <td>{item.predicted_drg2}</td>
                      <td>{item.predicted_drg1_path}</td>
                      <td>{item.predicted_drg2_path}</td>
                      {/* <td>{item.actual_weight}</td> */}
                      {/* <td>{item.predicted_drg1_weight}</td> */}
                      {/* <td>{item.predicted_drg2_weight}</td> */}
                      <td>
                        {"$" + Math.round(Number(item.actual_reimbursement)).toLocaleString("en-IN")}
                      </td>
                      <td
                      >
                        {"$" + Math.round(Number(item.predicted_drg1_reimbursement)).toLocaleString("en-IN")}
                      </td>
                      <td

                      >
                        {"$" + Math.round(Number(item.predicted_drg2_reimbursement)).toLocaleString("en-IN")}
                      </td>
<td
  style={{
    backgroundColor: getFinalHeatColor(roundedValueDelta1, min, max),
    fontWeight: 500,
  }}
>
  {"$" + roundedValueDelta1.toLocaleString("en-IN")}
</td>
                      <td
                        style={{
                          backgroundColor: getFinalHeatColor(
                            roundedValueDelta2,
                            min,
                            max,
                          ),
                          fontWeight: 500,
                        }}
                      >
                        {"$" + roundedValueDelta2.toLocaleString("en-IN")}
                      </td>
                      <td className="sticky-right">
                        <span
                          className={`priority-badge ${item.pallas_priority?.toLowerCase()}`}
                        >
                          {item.pallas_priority}
                        </span>
                      </td>
                    </tr>
                  )})
                ) : (
                  <tr>
                    <td colSpan="22" className="empty-state">
                      {isLoading
                        ? "Loading..."
                        : isReportUnavailable
                          ? "Report unavailable. Optimization algorithm is not applicable for this file."
                          : "No records present."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper">
            <button
              disabled={reportPage === 1}
              onClick={() => handlePageChange(reportPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              Page {reportPage} of {totalPageCount}
            </span>

            <button
              disabled={reportPage === totalPageCount}
              onClick={() => handlePageChange(reportPage + 1)}
            >
              Next ➡
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PallasReport;
